"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isCnMarket'])
})(({
  isCnMarket,
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: '3rem',
  ...(isCnMarket && {
    color: theme.palette.error.main
  }),
  '&:hover, &:focus, &:active': {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    ...(isCnMarket && {
      color: theme.palette.error.main
    })
  }
}));
